<template>
    <div>
        <b-card no-body>
            <b-card-body class="p-0">
                <p>
                    <label style="font-weight: bold">{{ $translate('total_quantity') }}</label>&nbsp;{{ totalQty }}
                </p>
                <b-table striped hover responsive :items="inventoryList" :fields="fields">
                    <template #cell(id)>
                        <button size="sm" v-if="hasPermissionUpdate" class="mr-2" variant="info" disabled>
                            <img src="@/assets/images/icon/manage.svg" />
                        </button>
                    </template>
                    <template #cell(location_section)="{ item }">
                        <div v-html="getInventoryLocation(item)"></div>
                    </template>
                </b-table>
            </b-card-body>
        </b-card>
    </div>
</template>

<script>
import permissionsMixins from '@/mixins/permissionsMixins'
export default {
    name: 'MasterItems-itemInventory',
    mixins: [permissionsMixins],
    props: ['inventoryList', 'totalQty'],
    data() {
        return {
        }
    },

    computed: {
        fields() {
            return [
                { key: 'id', label: '' },
                {
                    key: 'location_section',
                    label: this.$translate('locations'),
                    formatter: value => `${value.location.name}, ${value.name}`,
                },
                {
                    key: 'quantity_on_hand',
                    label: this.$translate('qty_on_hand'),
                },
            ]
        }
    },

    methods: {
        getInventoryLocation({ location_section }) {
            console.log('location_section', location_section)
            if (!location_section) {
                return ''
            }

            if (location_section.officers.length) {
                return (
                    `<strong>Officer</strong>: ` +
                    (location_section.officers[0] &&
                        location_section.officers[0].first_name +
                        ' ' +
                        location_section.officers[0].last_name)
                )
            } else {
                return (
                    location_section.location.name + `:` + location_section.name
                )
            }
        },
    },
}
</script>